import React from "react";
import "./ChampionsList.css";

type Team = "BLUE" | "RED";
type Role = "TOP" | "JGL" | "MID" | "ADC" | "SUP";

type Unit = {
  id: string;
  team: Team;
  role: Role;
  x: number;
  y: number;
  range: number;
  health: number;
  maxHealth: number;
};

interface ChampionsListProps {
  units: Unit[];
  selectedId: string | null;
  onSelectUnit: (id: string) => void;
  onSetRange: (unit: Unit, range: number) => void;
}

const ROLES: Role[] = ["TOP", "JGL", "MID", "ADC", "SUP"];
const TEAM_BG: Record<Team, string> = { BLUE: "#3B82F6", RED: "#EF4444" };
const roleShort = (role: Role) => (role === "JGL" ? "JG" : role);

export default function ChampionsList({ units, selectedId, onSelectUnit, onSetRange }: ChampionsListProps) {
  return (
    <div className="tf-card tf-champions-list">
      <h2 className="tf-champions-list__title">Units</h2>
      {(["BLUE", "RED"] as Team[]).map((team) => (
        <div key={team} className="tf-champions-list__team">
          <div className="tf-champions-list__team-name">{team}</div>
          {ROLES.map((role) => {
            const u = units.find((x) => x.team === team && x.role === role)!;
            const selected = selectedId === u.id;
            return (
              <div
                key={u.id}
                onClick={() => onSelectUnit(u.id)}
                className={`tf-champions-list__unit ${selected ? "tf-champions-list__unit--selected" : ""}`}
              >
                <div 
                  className="tf-champions-list__unit-indicator" 
                  style={{ background: TEAM_BG[team] }} 
                />
                <div className="tf-champions-list__unit-role">{roleShort(role)}</div>
                <div className="tf-champions-list__unit-position">
                  ({u.x},{u.y})
                </div>
                <div className="tf-champions-list__unit-health">
                  {u.health}/{u.maxHealth} HP
                </div>
                <div className="tf-champions-list__unit-range">
                  <label className="tf-champions-list__range-label">range</label>
                  <input 
                    type="number" 
                    step={1} 
                    min={0} 
                    value={u.range} 
                    onChange={(e) => onSetRange(u, Number(e.target.value))} 
                    className="tf-champions-list__range-input" 
                    onClick={(e) => e.stopPropagation()}
                  />
                </div>
              </div>
            );
          })}
        </div>
      ))}
    </div>
  );
}

export type { Unit, Team, Role };
